<template>
  <div>
    <custom-loading-component/>
    <qr-reader ref="qrReader" @reduceSuccess="commitPay" @success="commitQrCode"/>
    <vs-row vs-type="block" vs-w="12">
      <vs-popup fullscreen :active.sync="isActive" id="orderList" @update:active="handlePopupUpdate">
        <calc v-if="isPosEnabled" ref="calculatorPage" @closeEvent="closeCalculatorPage" @doPay="doPay" @setIsPieced="setIsPieced"
              :totalPrice="separatePaymentPrice"
              :currentDate="currentDate" :currentTime="currentTime"/>
        <calc v-if="!isPosEnabled" ref="calculatorPage" @closeEvent="closeCalculatorPage" @doPay="doPayWithoutPos"
              :totalPrice="separatePaymentPrice"
              :currentDate="currentDate" :currentTime="currentTime"/>
        <vs-row vs-type="flex" vs-w="12" class="p-0 m-0">
          <vs-button size="large" color="transparent" class="payment-label bg-primary2 text-white w-full"
                     icon-pack="feather" icon="icon-credit-card">
            Ödeme Ekranı
          </vs-button>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="info-row px-3" vs-justify="space between" v-if="activePersonel">
          <vs-col vs-w="6" vs-type="flex" vs-justify="flex-start" vs-align="center">
            <p class="text-primary bold">
              Personal Adı :
            </p>
            <p class="text-primary ml-2 weight-500">
              {{ activePersonel ? activePersonel.name : "" }}
            </p>
          </vs-col>
          <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end" vs-align="center">
            <p class="text-primary weight-600 mr-3">{{ currentDate }}</p>
            <p class="text-primary weight-500">{{ currentTime }}</p>
          </vs-col>
        </vs-row>
        <div id="data-list-thumb-view" class="data-list-container">
          <vs-table multiple :data="paymentGroups" v-model="selectedPaymentGroup" id="orderListTable">
            <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
            </div>
            <template slot="thead">
              <vs-th class="w-6/12">
                <p class="column-head-text">Ürün</p>
              </vs-th>
              <vs-th class="w-3/12">
                <p class="column-head-text">Ekstra</p>
              </vs-th>
              <vs-th class="w-3/12">
                <p class="column-head-text">Fiyat</p>
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr" style="height:5rem;"
                     :class="{'bg-secondary2': indextr % 2 != 0}">
                <vs-td class="w-6/12">
                  <vs-row vs-type="block" vs-w="12" v-for="entry in tr.entries" :key="entry.id">
                    <p class="text-center tr-text text-primary">
                      {{ entry.productName + (entry.quantity > 1 ? ' - x' + entry.quantity : '') }}</p>
                    <p v-show="rawmaterial.selected && rawmaterial.isDefault == false"
                       v-for="(rawmaterial, rawMaterialIndex) in entry.recipe.steps" :key="rawMaterialIndex"
                       class="text-center tr-text-child text-primary">
                      {{ rawmaterial.name }}
                    </p>
                  </vs-row>
                </vs-td>
                <vs-td class="w-4/12">
                  <vs-row vs-type="block" vs-w="12" v-for="entry in tr.entries" :key="entry.rowId">
                  <span class="tr-text-child text-center text-primary" v-for="extra in entry.extras" :key="extra.id">
                    <p class="product-extra text-primary" v-if="extra.quantity > 0 && (extra.variants.length == 0)">
                      x{{ extra.quantity }} | {{ extra.name }}
                    </p>
                    <p style="display:block;" class="product-extra text-primary" v-else-if="(extra.variants.length > 0)"
                       v-for="seletedVariantExtra in returnSelectedExtraVariant(extra)" :key="seletedVariantExtra">
                      {{ seletedVariantExtra }}
                    </p>
                  </span>
                  </vs-row>
                </vs-td>
                <vs-td class="w-1/12">
                  <vx-tooltip v-if="tr.entries.some(x=> x.originPrice != x.price && x.originPrice)"
                              :text="getTotalGift(tr) + 'İndirim'" position="top">
                    <feather-icon icon='GiftIcon' svgClasses='h-5 w-5' class='text-success'/>
                  </vx-tooltip>
                  <span v-if="tr.payedPrice > 0 && tr.payedPrice != tr.totalPrice"
                        class="text-center text-primary tr-text w-full line-through">
                  {{ $toCurrency(tr.totalPrice) }}
                </span>
                  <p class="text-center text-primary tr-text w-full"
                     :class="{'payed-row': tr.totalPrice-tr.payedPrice == 0}">{{
                      (tr.totalPrice - tr.payedPrice != 0 ? $toCurrency(tr.totalPrice -
                        tr.payedPrice) : "Ödendi")
                    }} ₺</p>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-row vs-type="flex" vs-w="12" class="px-5" style="background:#FFD1D1;!important;height:60px;">
            <vs-col vs-type="flex" vs-w="5" vs-justify="flex-start">
              <div class="w-auto flex align-center">
                <div class="d-flex align-center pointer">
                  <p class="price-label bold mr-3">
                    Toplam Tutar:
                  </p>
                  <p class="price bold mr-3">
                    {{ $toCurrency(totalPrice) }}
                  </p>
                  <vs-button v-show="orderPayments != null && orderPayments.length > 0"
                             @blur="showPaymentHistory = false"
                             @click="showPaymentHistory=!showPaymentHistory" icon-pack="feather"
                             icon="icon-more-horizontal" radius
                             size="small" color="transparent" class="sale-box-shadow bg-secondary text-primary"/>
                </div>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="2" vs-justify="center">
              <vs-checkbox class="bold text-primary" v-model="isPrintOrders">Fiş Yazdırılsın</vs-checkbox>
            </vs-col>
            <vs-col vs-type="flex" vs-w="5" vs-justify="flex-end">
              <div class="flex justify-flex-end align-center">
                <p class="price-label bold mr-5">
                  Seçilen Tutar:
                </p>
                <p class="price bold">
                  {{ $toCurrency(selectedGroupsPrice) }}
                </p>
              </div>
            </vs-col>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-type="block" vs-w="2">
              <transition name="fade">
                <div v-show="showPaymentHistory && orderPayments.length > 0"
                     class="payment-history w-full text-primary">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-row class="payment-log bold" vs-type="flex" vs-w="12" vs-justify="center"
                            v-for="log in orderPayments" :key="log.id">
                      {{ $toCurrency(log.price) }} {{ log.paymentMethod.name }}
                    </vs-row>
                  </vs-row>
                </div>
              </transition>
            </vs-col>
            <vs-col vs-type="block" vs-w="8">
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-3">
                  <select-payment-type ref="selectPaymentType" :dontCloseCalc="false" :totalPrice="totalPrice"
                                       :currentDate="currentDate" :currentTime="currentTime"/>
                </vs-row>
                <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-1 py-2">
                  <vs-col vs-type="flex" vs-w="3" vs-justify="flex-end" class="mr-2">
                    <vs-button @click="isActive = false;" :disabled="isPaymentStarted" size="large" color="primary" type="gradient"
                               class="bold half-friendly-border sale-box-shadow w-64" icon-pack="feather"
                               icon="icon-arrow-left">
                      Geri
                      Dön
                    </vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="3" vs-justify="flex-start" class="ml-2 mr-2">
                    <vs-button v-if="!isCommitable&&isPosEnabled" color="transparent"
                               class="text-white bg-success p-1 bold sale-box-shadow w-64 text-medium-small"
                               @click="doPay(selectedPaymentGroup.length>0?selectedGroupsPrice: totalPrice,false)">
                      {{ selectedPaymentMethod ? selectedPaymentMethod.name : null }} ile Öde
                      {{ selectedPaymentGroup.length > 0 ? $toCurrency(selectedGroupsPrice) : $toCurrency(totalPrice) }}
                    </vs-button>
                    <vs-button v-if="!isCommitable&!isPosEnabled" color="transparent"
                               class="text-white bg-success p-1 bold sale-box-shadow w-64 text-medium-small"
                               @click="doPayWithoutPos(selectedPaymentGroup.length>0?selectedGroupsPrice: totalPrice,false)">
                      {{ selectedPaymentMethod ? selectedPaymentMethod.name : null }} ile Öde
                      {{ selectedPaymentGroup.length > 0 ? $toCurrency(selectedGroupsPrice) : $toCurrency(totalPrice) }}
                    </vs-button>
                    <transition name="slide-fade">
                      <vs-button :disabled="isTransaction" v-if="isCommitable" size="large" color="transparent"
                                 @click="createCommitModel"
                                 class="glowing w-64 text-white bg-success3 bold sale-box-shadow">
                        Sepeti Bitir
                      </vs-button>
                    </transition>
                  </vs-col>
                </vs-row>
              </vs-row>
            </vs-col>
            <vs-col vs-type="flex" vs-w="2" vs-justify="flex-end" vs-align="center">
              <div class="bg-secondary calc-button sale-box-shadow" @click="totalPrice != 0 ? seperatePayment() : null">
                <vs-button :disabled="totalPrice == 0" color="transparent" type="flat"
                           class="small-icon text-primary p-0"
                           icon-pack="feather" icon="icon-chevron-left"/>
                <vs-button :disabled="totalPrice == 0" color="transparent" type="flat"
                           class="large-icon text-primary p-0"
                           icon-pack="feather" icon="icon-percent"/>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <printer ref="printer" :orderEntries="orderBillEntries" v-if="isCommitable" :totalPrice="totalOriginPrice"
                 :totalDiscountPrice="totalDiscountPrice" :currentDateTime="currentDate + ' ' + currentTime"
                 :activePersonal="activePersonel ? activePersonel.name : ''"/>
        <discount ref="discount" @appendDiscount="appendDiscount"
                  :priceToDiscount="selectedPaymentGroup.length>0?selectedGroupsPrice: totalPrice"
                  :currentDate="currentDate"
                  :currentTime="currentTime"/>
      </vs-popup>

    </vs-row>
  </div>

</template>

<script>
import Discount from "./Discount";
import Printer from "./Printer.vue";
import Calc from "./Calc.vue";
import CustomLoadingComponent from "@/views/pages/customLoadingComponent";
import QrReader from "./QrReader.vue";
import {

  uuid
} from "vue-uuid";
import {
  completePayment
} from "@/api/SelfService";
import SelectPaymentType from "./SelectPaymentType.vue";
import {
  FindAvailableCampaigns
} from "@/api/Campaign.js";
import {getPosSettings} from "@/api/AppSettings";

export default {
  props: {
    currentTime: {
      type: String,
      required: true
    },
    currentDate: {
      type: String,
      required: true
    }
  },
  components: {
    CustomLoadingComponent,
    Calc,
    SelectPaymentType,
    Printer,
    Discount,
    QrReader
  },
  data() {
    return {
      cloneCurrentCart: [],
      selectedGift: null,
      isPosEnabled: false,
      isPrintOrders: true,
      orderBillEntries: [],
      isTransaction: false,
      showPaymentHistory: false,
      isCommitable: false,
      isPaymentStarted:false,
      selectedPaymentGroup: [],
      isActive: false,
      orderPayments: [],
      paymentGroups: [],
      separatePaymentPrice: 0,
      paymentDiscount: {},
      discounts: [],
      ids: [],
      isPieced:false,
      posType:0
    };
  },
  watch: {
    selectedPaymentGroup(newVal, oldVal) {
      if (newVal.length > 0) {
        let lastItem = newVal[newVal.length - 1];
        if (lastItem.totalPrice == lastItem.payedPrice) {
          this.selectedPaymentGroup = oldVal;
        }
      }
    },
    isActive: function (val) {
      if (val) {
        this.initValues();
        this.initGifts();
      } else {
        this.selectedPaymentGroup = [];
        this.paymentGroups = [];
        this.orderPayments = [];
      }
    },
    totalPrice: function (val) {
      if (val == 0 && this.isActive == true) {
        this.isCommitable = true;
        this.createCommitModel();
      } else {
        this.isCommitable = false;
      }
    },
    selectedPaymentMethod(val) {
      if (val.id == 4) this.isActiveDiscount = true;
    }
  },
  computed: {
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
    isCakeQuestioned: {
      get() {
        return this.$store.getters["selfservice/getCakeQuestioned"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setCakeQuestioned", val);
      }
    },
    totalDiscountPrice() {
      let paymentDiscounts = this.orderPayments.reduce(function (total, num) {
        if (num.paymentMethod.id == 4 && num.paymentMethod.name == "İndirim")
          return total + num.price;
        else return total + 0;
      }, 0);
      let campaignDiscounts = this.paymentGroups.reduce(function (total, num) {
        let totalEntries = num.entries.reduce(function (entriesTotal, entryDiscount) {
          return entriesTotal + Math.round((entryDiscount.originPrice - entryDiscount.price) * 1000) / 1000;
        }, 0);
        return total + totalEntries;
      }, 0);
      return paymentDiscounts + campaignDiscounts;
    },
    isActiveDiscount: {
      get() {
        return this.$refs.discount.isActive;
      },
      set(val) {
        this.$refs.discount.isActive = val;
      }
    },
    selectedPaymentMethod: {
      get() {
        return this.$store.getters["selfservice/getSelectedPaymentMethod"];
      },
      set(val) {
        if (val)
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);
      }
    },
    paymentMethods: function () {
      return this.$store.getters["selfservice/getPaymentMethods"];
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      }
    },
    totalOriginPrice: function () {
      return this.calculateTotalOriginPrice(this.paymentGroups);
    },
    totalPrice: function () {
      return this.calculateSelectedRemainingPrice(this.paymentGroups);
    },
    selectedGroupsPrice: function () {
      return this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
    },
    currentCart: {
      get() {
        return this.$store.getters["selfservice/getCurrentCart"];
      },
      set(payload) {
        this.$store.dispatch("selfService/setCurrentCartWithCampaign", payload);
      }
    },
    activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    },
    toggleCalc: {
      get() {
        return this.$refs.calculatorPage.isActive;
      },
      set(val) {
        this.$refs.calculatorPage.isActive = val;
      }
    },
  },

  methods: {
    commitQrCode(customer) {
      console.log(customer);
      console.log('çalıştı qr');
        this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);
        this.cloneCurrentCart = _.cloneDeep(this.currentCart);
        console.log(this.cloneCurrentCart);
      },
    getTotalGift(row) {
      let totalGift = row.entries.reduce(function (total, num) {
        if (num.originPrice - num.price > 0)
          return total + (num.originPrice - num.price);
        else return total + 0;
      }, 0);
      return this.$toCurrency(totalGift);
    },
    initValues() {
      this.selectedGift = null;
      this.orderPayments = [];
      this.paymentGroups = [];
      this.selectedPaymentGroup = [];
      this.cloneCurrentCart = _.cloneDeep(this.currentCart);
      this.generatePaymentGroups();
      this.isTransaction = false;
      this.isPrintOrders = true;
      this.isPaymentStarted = false;
    },
    generatePaymentGroups() {
      this.paymentGroups.length = 0;
      this.cloneCurrentCart.cartEntries.forEach((entry) => {
        let tempPaymentGroup = {
          rowIndex: uuid.v1(),
          entries: [],
          totalPrice: 0,
          payedPrice: 0,
          status: "Kalan"
        };
        tempPaymentGroup.rowIndex = uuid.v1();
        tempPaymentGroup.entries.push(entry);
        tempPaymentGroup.totalPrice = entry.price;
        tempPaymentGroup.payedPrice = 0;
        tempPaymentGroup.status = "Kalan";

        this.paymentGroups.push(_.cloneDeep(tempPaymentGroup));
      });
      this.reCalculatePaymentGroup();
    },
    initGifts() {
      let productIds = [];
      let categoryIds = [];
      let totalPrice = 0;
      if (this.cloneCurrentCart.customer) {
        let cart = this.cloneCurrentCart;
        cart.cartEntries.forEach(x => {
          x.categoryId = x.categories[0].id;
        });
        let payments = this.orderPayments;
        let orderModel = {
          id: cart.id,
          customerId: cart.customer ? cart.customer.id : null,
          qrCode: cart.customer ? cart.customer.giftQrCode : null,
          totalPrice: cart.totalPrice,
          active: cart.active,
          cartEntries: [...cart.cartEntries],
          branchName: this.$currentUser.branch.name,
          paymentInformations: [...payments],
          userName: this.activePersonel.name,
          userId: this.activePersonel.id,
        };
        FindAvailableCampaigns(orderModel).then(res => {
          if (res && res.status == 200) {
            if (res.data.isValid) {
              this.cloneCurrentCart.cartEntries = res.data.newEntries;
              if (res.data.customerGiftId != null) this.cloneCurrentCart.customerGiftId = res.data.customerGiftId;
              else if (res.data.campaignGiftId != null) this.cloneCurrentCart.campaignGiftId = res.data
                .campaignGiftId;
              this.generatePaymentGroups();
            }
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "Kampanyalara Erişilemedi !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kampanyalara Erişilemedi !"
            });
          }
        }).catch(() => {
          this.$fire({
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      }
    },
    appendDiscount(discountObj) {
      this.paymentDiscount = {
        paymentMethod: this.selectedPaymentMethod,
        value: discountObj.value,
        description: discountObj.description,
        unit: discountObj.unit,
        selectedPaymentGroup: this.selectedPaymentGroup.map(r => r.entries).map(j => j[0].id),
        payedPrice: discountObj.payedPrice,
        discountDescription : discountObj.discountDescription
      }
      if (this.isPosEnabled) {
        this.doPay(discountObj.priceToDiscount, true);

      } else {
        this.doPayWithoutPos(discountObj.priceToDiscount, true);
      }
      this.discounts.push(this.paymentDiscount)
      this.paymentDiscount = {}
    },
    returnSelectedExtraVariant(extra) {
      let returnObj = [];
      let selectedVariants = extra.variants.filter(x => {
        if (x.quantity > 0) {
          returnObj.push("x" + x.quantity + " | " + x.name);
        }
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    createCommitModel() {
      if (this.isTransaction == true) {
        return;
      }
      this.isTransaction = true;
      console.log(this.currentCart);
      let cart = this.cloneCurrentCart;
      debugger;
      let payments = this.orderPayments;
      let orderModel = {
        id: cart.id,
        isNavigatedByQuestion: cart.isNavigatedByQuestion,
        customerId: cart.customer ? cart.customer.id : null,
        customerGiftId: cart.customerGiftId ? cart.customerGiftId : null,
        campaignGiftId: cart.campaignGiftId ? cart.campaignGiftId : null,
        totalPrice: cart.totalPrice,
        active: cart.active,
        cartEntries: [...cart.cartEntries],
        branchName: this.$currentUser.branch.name,
        paymentInformations: [...payments],
        userName: this.activePersonel.name+" "+this.activePersonel.surname,
        userId: this.activePersonel.id,
        discounts: this.discounts
      };
      completePayment(orderModel).then(result => {
        this.discounts = []
        if (result && result === true) {
          let entryCount = this.orderPayments.length;
          let totalEntryPrice = this.orderPayments.reduce((a, b) => a + (b.price || 0), 0);
          this.orderPayments = [];
          this.isReset = true;
          this.isActive = false;
          this.isCakeQuestioned = false;
          if (this.isPrintOrders) this.$refs.printer.printOrders();
          this.$store.dispatch("selfservice/setLastBillId");
          //TODO AFTER PRINT
          this.$vs.notify({
            color: "success",
            title: totalEntryPrice.toFixed(2) + " Tutarında Sepet Tamamlandı !",
            text: payments.length + " Ödeme Gerçekleşti."
          });
        } else {
          this.$fire({
            title: "Hata !",
            text: "Ürün Satışı Tamamlanamadı !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Ürün Satışı Tamamlanamadı !"
          });
          // this.initValues();
          this.isTransaction = false;
        }
      }).catch(err => {
        this.$fire({
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
              type: "error"
            });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
        // this.initValues();,
        this.isTransaction = false;
      });
      this.discounts=[];
      this.isPieced = false;
    },
    seperatePayment() {
      if (this.selectedPaymentGroup.length > 0) {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
        this.toggleCalc = true;
      } else {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.paymentGroups);
        this.toggleCalc = true;
      }
    },
    checkPosDevice: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      let branchId = userInfo.branch.id
      let axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
      this.posType = axiosResponse.data.posType;
    },
    setIsPieced:function(){
      this.isPieced = true
    },
    doPayWithoutPos: function (payedPrice,isDiscount) {
      if (this.selectedPaymentMethod.id == process.env.VUE_APP_WALLET_PAYMENT_ID) {
        console.log(payedPrice);
        console.log(isDiscount);
        this.openQrReader(payedPrice,isDiscount);
        return;
      }
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: parseFloat(payedPrice),
        status: "Kalan"
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });

      let removedPaymentGroup = [];
      this.paymentGroups.forEach((x, index) => {
        if (!removeIndex.some(rm => rm == x.rowIndex)) {
          removedPaymentGroup.push(vm.paymentGroups[index]);
        }
      });
      removedPaymentGroup.push(tempGroup);
      this.paymentGroups = removedPaymentGroup;
      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
      this.selectedPaymentGroup = [];
      this.reCalculatePaymentGroup();
      
      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: this.selectedPaymentMethod,
        price: payedPrice,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null,
        discountDescription : isDiscount ? this.paymentDiscount.discountDescription : null,
      };
      this.orderPayments.push(orderPayment);
      this.isPaymentStarted = true;
      this.toggleCalc = false;
    },
    doPay: function (payedPrice, isDiscount) {
      if (this.posType == parseInt(process.env.VUE_APP_POS_GMP)) {
        this.doPayGmp(payedPrice,isDiscount);
        return;
      }
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: parseFloat(payedPrice),
        status: "Kalan"
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          // tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });
      let posSaleItems = [];
      if (this.isPieced == true) {
      var saleDto = {
        name: "İçecek",
        price: Math.round((payedPrice) * 1000) / 1000,
        quantity: 1,
        kdv: 10  
      }
      posSaleItems.push(saleDto);
      }
      else{
      this.selectedPaymentGroup.forEach(function(selectProduct){
        if (selectProduct.payedPrice != selectProduct.totalPrice) {
          let saleModel = {
              name : selectProduct.entries[0].productName,
              quantity : selectProduct.entries[0].quantity,
              kdv : 10,
              //price : selectProduct.entries[0].price
              price : selectProduct.totalPrice - selectProduct.payedPrice,
              //id : selectProduct.entries[0].categories[0].id
            };
            if (selectProduct.entries[0].categories && selectProduct.entries[0].categories.length > 0) {
              saleModel.id = selectProduct.entries[0].categories[0].id;
            }else{
              saleModel.id =selectProduct.entries[0].categoryId;
            }
            if (saleModel.id == 16) {
                saleModel.id = 1;
              }
            posSaleItems.push(saleModel); 
        }
          });
        }
      this.isLoading = true;
      if (isDiscount) {
        this.isLoading = false;
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = this.paymentGroups;
        }
        let removeIndex = [];
        let tempGroup = {
          rowIndex: uuid.v1(),
          entries: [],
          totalPrice: 0,
          payedPrice: parseFloat(payedPrice),
          status: "Kalan"
        };
        let vm = this;

        this.paymentGroups.forEach((item) => {
          tempGroup.rowIndex = uuid.v1();
          if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
            tempGroup.entries = tempGroup.entries.concat(item.entries);
            tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
            removeIndex.push(item.rowIndex);
          }
        });

        let removedPaymentGroup = [];

        this.paymentGroups.forEach((x, index) => {
          if (!removeIndex.some(rm => rm == x.rowIndex)) {
            removedPaymentGroup.push(vm.paymentGroups[index]);
          }
        });
        removedPaymentGroup.push(tempGroup);

        this.paymentGroups = removedPaymentGroup;

        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
        this.selectedPaymentGroup = [];

        this.reCalculatePaymentGroup();

        let orderPayment = {
          id: uuid.v1(),
          paymentMethod: this.selectedPaymentMethod,
          price: payedPrice,
          value: isDiscount ? this.paymentDiscount.value : null,
          unit: isDiscount ? this.paymentDiscount.unit : null,
          description: isDiscount ? this.paymentDiscount.description : null,
          discountDescription : isDiscount ? this.paymentDiscount.discountDescription : null,
        };
        this.orderPayments.push(orderPayment);
        // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
        this.toggleCalc = false;
      } else {
        if (this.selectedPaymentMethod.id != process.env.VUE_APP_CASH_PAYMENT_ID && this.selectedPaymentMethod.id != process.env.VUE_APP_CREDIT_PAYMENT_ID) {
          this.doPayWithoutPos(payedPrice,isDiscount);
          this.isLoading = false;
          return;
        }
        // var token = localStorage.getItem("auth-token");
        fetch(process.env.VUE_APP_POS_API + "complete-sale", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            PaymentType: this.selectedPaymentMethod.id == process.env.VUE_APP_CREDIT_PAYMENT_ID ? 4 : 1,
            SaleItems: posSaleItems,
          }),
        }).then((response) => response.json())
              .then((data) => {
                this.isLoading = false;
                if (data.hasError==true) {
                  this.$vs.notify({
                    color: "danger",
                    title: "Hata",
                    text: data.message
                  });
                  this.$fire({
                  title: "İptal",
                  text: data.message,
                  type: "error"
                });
                  return;
                }
                if (data.data.statusId == 4) {
                  this.isPaymentStarted = true;
                  let posStatusId = data.data.addedPayments.find(payment => payment.statusId === 2).paymentTypeId;
                  if (this.selectedPaymentGroup.length == 0) {
                    this.selectedPaymentGroup = this.paymentGroups;
                  }
                  let removeIndex = [];
                  let tempGroup = {
                    rowIndex: uuid.v1(),
                    entries: [],
                    totalPrice: 0,
                    payedPrice: parseFloat(payedPrice),
                    status: "Kalan"
                  };
                  let vm = this;

                  this.paymentGroups.forEach((item) => {
                    tempGroup.rowIndex = uuid.v1();
                    if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
                      tempGroup.entries = tempGroup.entries.concat(item.entries);
                      tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
                      removeIndex.push(item.rowIndex);
                    }
                  });

                  let removedPaymentGroup = [];

                  this.paymentGroups.forEach((x, index) => {
                    if (!removeIndex.some(rm => rm == x.rowIndex)) {
                      removedPaymentGroup.push(vm.paymentGroups[index]);
                    }
                  });
                  removedPaymentGroup.push(tempGroup);

              this.paymentGroups = removedPaymentGroup;

              this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
              this.selectedPaymentGroup = [];

              this.reCalculatePaymentGroup();

                  let orderPayment = {
                    id: uuid.v1(),
                    paymentMethod: _.cloneDeep(this.selectedPaymentMethod),
                    price: payedPrice,
                    value: isDiscount ? this.paymentDiscount.value : null,
                    unit: isDiscount ? this.paymentDiscount.unit : null,
                    description: isDiscount ? this.paymentDiscount.description : null
                  };
                  orderPayment.paymentMethod.id = posStatusId;
                  if (data.data.financialDocuments && data.data.financialDocuments.length > 0) {
                    orderPayment.financialDocument = data.data.financialDocuments[0];
                    orderPayment.financialDocument.saleUid = data.data.saleUid;
                    orderPayment.financialDocument.orderNo = data.data.orderNo;
                  }
                  
                  console.log(orderPayment);
                  // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
                  this.orderPayments.push(orderPayment);
                  this.toggleCalc = false;
                } else {
                  this.$fire({
                  title: "İptal",
                  text: "Ödeme iptal edildi",
                  type: "error"
                });
                  this.$vs.notify({
                    color: "danger",
                    title: data.message,
                    text: ""
                  });
                }
              })
              .catch(err => {
                this.isLoading = false;
                this.$fire({
                title: "Hata !",
                text: "İstek başarısız oldu. Tekrar Deneyiniz.",
                  type: "error"
                });
                this.$vs.notify({
                  color: "danger",
                  title: "İstek başarısız oldu. Tekrar Deneyiniz.",
                  text: ""
                });
              });
          }
        },
    reCalculatePaymentGroup: function () {
      this.paymentGroups.forEach(pgroup => {
        let totalPrice = 0;

        pgroup.entries.forEach(entry => {
          totalPrice += Math.round(entry.price * 100) / 100;
        });
        pgroup.totalPrice = Math.round(totalPrice * 100) / 100;
      });
    },
    doPayGmp: function (payedPrice, isDiscount) {
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: parseFloat(payedPrice),
        status: "Kalan"
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          // tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });
      let posSaleItems = [];
      var saleDto = {
        name: "İçecek",
        price: Math.round((payedPrice) * 1000) / 1000,
        quantity: 1,
        kdv: 10
      }
      posSaleItems.push(saleDto);
      this.isLoading = true;
      if (isDiscount) {
        this.isLoading = false;
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = this.paymentGroups;
        }
        let removeIndex = [];
        let tempGroup = {
          rowIndex: uuid.v1(),
          entries: [],
          totalPrice: 0,
          payedPrice: parseFloat(payedPrice),
          status: "Kalan"
        };
        let vm = this;

        this.paymentGroups.forEach((item) => {
          tempGroup.rowIndex = uuid.v1();
          if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
            tempGroup.entries = tempGroup.entries.concat(item.entries);
            tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
            removeIndex.push(item.rowIndex);
          }
        });

        let removedPaymentGroup = [];

        this.paymentGroups.forEach((x, index) => {
          if (!removeIndex.some(rm => rm == x.rowIndex)) {
            removedPaymentGroup.push(vm.paymentGroups[index]);
          }
        });
        removedPaymentGroup.push(tempGroup);

        this.paymentGroups = removedPaymentGroup;

        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
        this.selectedPaymentGroup = [];

        this.reCalculatePaymentGroup();

        let orderPayment = {
          id: uuid.v1(),
          paymentMethod: this.selectedPaymentMethod,
          price: payedPrice,
          value: isDiscount ? this.paymentDiscount.value : null,
          unit: isDiscount ? this.paymentDiscount.unit : null,
          description: isDiscount ? this.paymentDiscount.description : null
        };
        this.orderPayments.push(orderPayment);
        // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
        this.toggleCalc = false;
      } else {
        // var token = localStorage.getItem("auth-token");
        fetch(process.env.VUE_APP_POS_API + "create", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            PaymentType: this.selectedPaymentMethod.id == process.env.VUE_APP_CREDIT_PAYMENT_ID ? 4 : 1,
            SaleItems: posSaleItems,
          }),
        }).then((response) => response.json())
          .then((data) => {
            this.isLoading = false;
            if (data.statusCode == 200) {
              if (this.selectedPaymentGroup.length == 0) {
                this.selectedPaymentGroup = this.paymentGroups;
              }
              let removeIndex = [];
              let tempGroup = {
                rowIndex: uuid.v1(),
                entries: [],
                totalPrice: 0,
                payedPrice: parseFloat(payedPrice),
                status: "Kalan"
              };
              let vm = this;

              this.paymentGroups.forEach((item) => {
                tempGroup.rowIndex = uuid.v1();
                if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
                  tempGroup.entries = tempGroup.entries.concat(item.entries);
                  tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
                  removeIndex.push(item.rowIndex);
                }
              });

              let removedPaymentGroup = [];

              this.paymentGroups.forEach((x, index) => {
                if (!removeIndex.some(rm => rm == x.rowIndex)) {
                  removedPaymentGroup.push(vm.paymentGroups[index]);
                }
              });
              removedPaymentGroup.push(tempGroup);

              this.paymentGroups = removedPaymentGroup;

              this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
              this.selectedPaymentGroup = [];

              this.reCalculatePaymentGroup();

              let orderPayment = {
                id: uuid.v1(),
                paymentMethod: this.selectedPaymentMethod,
                price: payedPrice,
                value: isDiscount ? this.paymentDiscount.value : null,
                unit: isDiscount ? this.paymentDiscount.unit : null,
                description: isDiscount ? this.paymentDiscount.description : null
              };
              // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
              this.orderPayments.push(orderPayment);
              this.toggleCalc = false;
            } else {
              this.$fire({
              title: data.message,
              text: "",
              type: "error"
            });
              this.$vs.notify({
                color: "danger",
                title: data.message,
                text: "",
                position:'center'
              });
            }
          })
          .catch(err => {
            this.isLoading = false;
            this.$fire({
            title: "Hata !",
            text: "İstek başarısız oldu. Tekrar Deneyiniz.",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "İstek başarısız oldu. Tekrar Deneyiniz.",
              text: ""
            });
          });
      }
    },
    calculateTotalOriginPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach(item => {
        item.entries.forEach(entry => {
          selectedPrice += entry.originPrice;
        })
      });
      return Math.round(selectedPrice * 100) / 100;
    },
    commitPay(payedPrice,isDiscount){
      console.log('tamamlandı commit');
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      if (this.cloneCurrentCart.customer) {
        let cart = this.cloneCurrentCart;
        cart.cartEntries.forEach(x => {
          x.categoryId = x.categories[0].id;
        });
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: parseFloat(payedPrice),
        status: "Kalan"
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          console.log(item);
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });

      let removedPaymentGroup = [];
      this.paymentGroups.forEach((x, index) => {
        if (!removeIndex.some(rm => rm == x.rowIndex)) {
          removedPaymentGroup.push(vm.paymentGroups[index]);
        }
      });
      removedPaymentGroup.push(tempGroup);
      this.paymentGroups = removedPaymentGroup;
      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
      this.selectedPaymentGroup = [];
      this.reCalculatePaymentGroup();
      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: this.selectedPaymentMethod,
        price: payedPrice,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null
      };
      this.orderPayments.push(orderPayment);
      this.toggleCalc = false;
      this.$vs.notify({
            color: "success",
            title: "Tebrikler",
            text: payedPrice+ " TL Değerinde Ödeme Gerçekleşti."
          });
    },
    openQrReader(amount,isDiscount) {
        this.$refs.qrReader.isActive = true;
        this.$refs.qrReader.isWallet = true;
        this.$refs.qrReader.amount = amount.toFixed(2);
        this.$refs.qrReader.isDiscount = isDiscount;
      },
    calculateSelectedRemainingPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach(item => {
        selectedPrice += (item.totalPrice - item.payedPrice);
      });
      return selectedPrice;
    },
    closeCalculatorPage() {
      this.isCalculatorPageActive = false;
    },
    handlePopupUpdate(newValue) {
      // Pop-up durumu güncellendiğinde tetiklenir
      if (this.isPaymentStarted) {
        // Pop-up kapatıldığında yapılacak işlemler
        this.isActive = true; // Pop-up'ı tekrar açmak için
      }
    }
  },
  created() {
    this.checkPosDevice();
    this.isPaymentStarted = false;
  }
};
</script>

<style>
.payment-log {
  border-bottom: .1rem solid black
}

.payment-history::-webkit-scrollbar {
  height: 0;
  width: 0;
}

.payment-history {
  border: .1rem solid black;
  border-left: none;
  border-top: none;
  border-bottom: none;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-radius: 1rem;
  background: #FFD1D1;
  overflow: auto;
  max-height: 185px;
}

#orderListTable .vs-table--content {
  height: calc(100vh - 385px);
}

.calc-button .includeIconOnly {
  width: unset !important;
  height: unset !important;
}

.calc-button {
  padding: 1rem 0.5rem !important;
  width: fit-content;
  display: flex;
}

.calc-button .large-icon i {
  font-size: 2.5rem !important;
  color: var(--vs-primary);
}

.calc-button .small-icon i {
  font-size: 1.5rem !important;
}

.info-row {
  padding: 0.75rem .75rem !important;
  border-top: 1px solid;
  background: #F9F5F5 !important;
  font-size: 1.1rem !important;
  padding-bottom: 0 !important;
}

#orderList .vs-popup .vs-popup--content {
  height: 97vh !important;
  max-height: 100vh !important;
  overflow: hidden;
}

#orderList .vs-popup .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
}

#orderList .vs-popup {
  border-radius: 2rem !important;
}

#orderList .vs-popup .vs-popup--header {
  display: none;
}

.payment-label {
  font-size: 1.25rem !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 2rem !important;
  border-top-right-radius: 2rem !important;
}

.payment-label i {
  font-size: 3rem !important;
  margin-right: 2rem !important;
}

#orderList .vs-table--tbody-table tr {
  background: none;
}

#orderList .giftsOpenerButton {
  z-index: 600;
}

#orderListTable .vs-table--content .vs-con-tbody .vs-table .vs-table--thead {
  background: #FFD1D1;
}

#orderListTable .con-tablex .vs-con-tbody .vs-table .vs-table--thead tr th .vs-table-text {
  border: none !important;
}

#orderListTable .con-tablex .vs-con-tbody .vs-table .vs-table--thead tr th {
  padding-bottom: 0 !important;
}

.column-head-text {
  font-size: 1.1rem !important;
  color: #543633 !important;
}

.tr-text {
  font-size: 1.1rem !important;
  font-weight: bold;
}

.tr-text-child {
  font-size: 1rem !important;
  font-weight: 600;
  font-style: italic;
}

.vs-table-primary .is-selected {
  background: #B8EEB8 !important;
}

.price-label {
  font-size: 1.1rem !important;
  color: #543633 !important;
  font-weight: 600 !important;
}

.price {
  font-size: 1.75rem !important;
  color: #543633 !important;
  line-height: 1.75rem !important;
}

.payed-row {
  color: rgb(130, 223, 130) !important;
  text-shadow: 0px 0px 3px rgb(226, 226, 226);
}
.swal2-container {
  z-index: 99999;
}
</style>
